module.exports = "#define GLSLIFY 1\nvarying vec3 vPickerColor;\n\nvoid main() {\n    gl_FragColor = vec4(vPickerColor.rgb, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/libs/geometry/node/shaders/pick.frag
// module id = 49
// module chunks = 0